export default [

  {
    value: "unassigned",
    label: "Ubekreftet",
    filterDefault: false
  },
  {
    value: "assigned",
    label: "Oppdrag bekreftet",
    filterDefault: false
  },
  {
    value: "gridPermissionApplied",
    label: "Søknad sendt til netteier",
    filterDefault: false
  },
  {
    value: "hardwareWanted",
    label: "Valgt lader kan sendes",
    filterDefault: false
  },
  {
    value: "installationDateSet",
    label: "Montering avtalt",
    filterDefault: false
  },

  {
    value: "completed",
    label: "Ferdig installert",
    filterDefault: false
  }
]


